export default __webpack_public_path__ + "static/media/1671217015713.2bf64565.jpg";